var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.8 1.6a.8.8 0 0 0 0 1.6h6.4a.8.8 0 0 0 0-1.6H8.8Zm-4 4a.8.8 0 0 1 .8-.8h12.8a.8.8 0 0 1 0 1.6h-.8v12.8a1.6 1.6 0 0 1-1.6 1.6H8a1.6 1.6 0 0 1-1.6-1.6V6.4h-.8a.8.8 0 0 1-.8-.8Zm3.2.8h8v12.8H8V6.4Z"
  })));
};

export default SvgTrash;